module.exports = __webpack_public_path__ + "img/small_logo.439999c5.gif";